import { Box, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useStore } from "@roc/client-portal-shared/hooks";
import { Layout } from "@roc/feature-app-core";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { DashboardAutocompleteField } from "./DashboardsAutocompleteField";
import { DataGrid, GridColumnProps, SelectField } from "@roc/ui";
import { businessUnitOptions } from "@roc/feature-utils";

const useStyles = makeStyles((theme) => ({
  button: {},
  paper: {},
  pageLayoutContainer: {
    padding: "2.5px",
  },
  title: {
    marginLeft: "15px",
    marginTop: "-20px",
  },
  container: {
    marginTop: "0px",
  },
}));

const columns: GridColumnProps[] = [
  {
    field: "fullName",
    headerName: "Full Name",
    minWidth: 140,
  },
  {
    field: "brand",
    headerName: "Brand",
    minWidth: 140,
  },
  {
    field: "totalRecords",
    headerName: "Total Records",
    minWidth: 100,
  },
  {
    field: "outboundCalls",
    headerName: "Outbound Calls",
    minWidth: 100,
  },
  {
    field: "answers",
    headerName: "Outbound Calls Answered",
    minWidth: 100,
  },
  {
    field: "inboundCalls",
    headerName: "Inbound Calls",
    minWidth: 100,
  },
  {
    field: "missedInboundCalls",
    headerName: "Missed Inbound Calls",
    minWidth: 100,
  },
  {
    field: "emailsSent",
    headerName: "Emails Sent",
    minWidth: 100,
  },
  {
    field: "voicemail",
    headerName: "Voicemail",
    minWidth: 100,
  },
  {
    field: "loansSubmitted",
    headerName: "Loans Submitted",
    minWidth: 100,
  },
  {
    field: "crBgPulled",
    headerName: "Credit & Background Check",
    minWidth: 170,
  },
];

const ALL_LEADS = "all_leads";

export const UserMetricsByDashboard = observer(() => {
  const classes = useStyles();
  const { salesforceLeadStore } = useStore();
  const { leadsDashboardStore } = salesforceLeadStore;
  const { userMetricsDashboardGridStore } = leadsDashboardStore;

  useEffect(() => {
    leadsDashboardStore.fetchDashboardsForUserMetrics();
  }, []);

  const onSortChanged = (params) => {
    const sortModel = params.api.getSortModel();
    userMetricsDashboardGridStore.setSortModel(sortModel);
  };

  const onFilterChanged = (params) => {
    const filterModel = params.api.getFilterModel();
    userMetricsDashboardGridStore.setFilterModel(filterModel);
  };

  return (
    <Layout>
      <DataGrid
        className={classes.container}
        columns={columns}
        toolbar={<CustomToolbar salesforceLeadStore={salesforceLeadStore} />}
        rows={userMetricsDashboardGridStore.gridData.data.rows}
        onSortChanged={onSortChanged}
        onFilterChanged={onFilterChanged}
        isLoading={userMetricsDashboardGridStore.isLoading}
        showFilters={userMetricsDashboardGridStore.showFilters}
        sortModel={userMetricsDashboardGridStore.sortModel}
        filterModel={userMetricsDashboardGridStore.filterModel}
        paginationData={userMetricsDashboardGridStore.gridData.meta}
        setPageNumber={userMetricsDashboardGridStore.setPageNumber}
        enablePaginationSelectPage={true}
      />
    </Layout>
  );
});

const CustomToolbar = observer(({ salesforceLeadStore }) => {
  const { leadsDashboardStore } = salesforceLeadStore;
  const { dashboards, standardDashboards, currentDashboardId } = leadsDashboardStore;
  const [businessUnit, setBusinessUnit] = useState<string>(null);

  const handleOnChange = (value) => {
    setBusinessUnit(value);
    leadsDashboardStore.setBusinessUnit(value);
    leadsDashboardStore.fetchDashboardsForUserMetrics();
  }


  const isReady = dashboards?.length > 0 || standardDashboards?.length > 0;
  return (
    <>
      <Grid container alignItems="center">
        <Grid item xs={3}>
          <Box p={1.5}>
            {isReady && (
              <DashboardAutocompleteField
                store={salesforceLeadStore}
                isNotCrmDashboard={true}
              />
            )}
          </Box>
        </Grid>
        <Grid item xs={3}>
          <Box p={1.5}>
            {isReady && (
              <SelectField
                value={businessUnit}
                options={businessUnitOptions}
                onChange={value => {
                  handleOnChange(value)
                }}
                fullWidth
                variant={'outlined'}
                testId={'businessUnit'}
                style={{ height: '35px' }}
              />
            )}
          </Box>
        </Grid>
      </Grid>
    </>
  );
});
